import React, { createContext, useState } from 'react';
import {
    fetchUserDetails, fetchUserAddress, fetchUserBikes,
    saveUserBikeOnServer, saveUserAddressOnServer,
    saveUserDetailsOnServer, delUserDetailsOnServer, delUserAdressesOnServer
} from './userProfile.service';

export const UserProfileProvider = createContext();

export const UserProfileContext = ({ children }) => {
    const clearUserSession = () => {
        localStorage.removeItem('userId');
        localStorage.removeItem('sessionToken');
    };
    const defaultBikeData = {
        manufacturer: 'Bergamont',
        gear_shifters_manufacturer: 'Shimano',
        gear_shifter: 'Kettenschaltung',
        breakes_manufacturer: 'Shimano',
        tire_tube: 'Dunlopventil',
        motor_manufacturer: 'Bosch',
        motor_type: 'Tretlagermotor',
        batterie_type: 'Rahmenakku (innenliegend)',
    };
    const defaultAddressData = {
        floor: 'Bitte geben SIe ein Geschoss an ',
        country: 'Bitte geben Sie ein Bundesland an',
        comment: 'Bitte geben SIe einen Kommentar an',
    };

    const [isLoading, setIsLoading] = useState(true);
    const [userDetails, setUserDetails] = useState({});
    const [userBikeDetails, setUserBikeDetails] = useState(defaultBikeData);
    const [userAddress, setUserAddress] = useState([]);
    const [userAddressDetails, setUserAddressDetails] = useState(defaultAddressData);
    const [userBikes, setUserBikes] = useState([]);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);



    const loadUserDetails = async () => {
        setIsLoading(true);
        try {
            const response = await fetchUserDetails();
            setIsLoading(false);
            const { data } = response;
            if (data.status.toLowerCase() === 'ok') {
                setError(null);
                setUserDetails(data.data[0]);
            } else {
                setError('Something went wrong');
            }
        } catch (error) {
            setTimeout(() => { window.location.href = '/auth/login'; }, 5000);
            setIsLoading(false);
            clearUserSession();
            setError('Session abgelaufen, bitte neu anmelden');
        }
    }
    const loadUserAddress = async () => {
        setIsLoading(true);
        try {
            const response = await fetchUserAddress();
            setIsLoading(false);
            const { data } = response;
            if (data.status.toLowerCase() === 'ok') {
                setError(null);
                setUserAddress(data.data);
            } else {
                setError('Something went wrong');
            }
        } catch (error) {
           setTimeout(() => { window.location.href = '/auth/login'; }, 5000);
            setIsLoading(false);
            clearUserSession();
            setError('Session abgelaufen, bitte neu anmelden');
        }
    }

    const loadUserBikes = async () => {
        setIsLoading(true);
        try {
            const response = await fetchUserBikes();
            setIsLoading(false);
            const { data } = response;
            if (data.status.toLowerCase() === 'ok') {
                setError(null);
                setUserBikes(data.data);
            } else {
                setError('Something went wrong');
            }
        } catch (error) {
            setTimeout(() => { window.location.href = '/auth/login'; }, 5000);
            setIsLoading(false);
            clearUserSession();
            setError('Session abgelaufen, bitte neu anmelden');
        }
    }

    const saveUserBike = async (bikeInfo) => {
        setIsLoading(true);
        try {
            const response = await saveUserBikeOnServer(bikeInfo);
            setIsLoading(false);
            const { data } = response;
            if (data.status.toLowerCase() === 'ok') {
                setUserBikeDetails(defaultBikeData);
                showSuccessMessage('Fahrrad wurde gespeichert');
                setError(null);
                loadUserBikes();

            } else {
                setError('Da hat etwas nicht geklappt');
            }
        } catch (error) {
            setIsLoading(false);
            setError('Da hat etwas nicht geklappt');
        }
    }

    const saveUserAddress = async (addressInfo) => {
        setIsLoading(true);
        try {
            const response = await saveUserAddressOnServer(addressInfo);
            setIsLoading(false);
            const { data } = response;
            if (data.status.toLowerCase() === 'ok') {
                setUserAddressDetails(defaultAddressData);
                showSuccessMessage('Adresse wurde gespeichert');
                setError(null);
                loadUserAddress();
            } else {
                setError('Da hat etwas nicht geklappt');
            }
        } catch (error) {
            setIsLoading(false);
            setError('Da hat etwas nicht geklappt');
        }
    }

    const saveUserDetails = async (userInfo) => {
        setIsLoading(true);

        try {
            const response = await saveUserDetailsOnServer(userInfo);
            setIsLoading(false);
            const { data } = response;
            if (data.status.toLowerCase() === 'ok') {
                showSuccessMessage('Informationen wurden gespeichert');
                setError(null);
                loadUserDetails();
            } else {
                setError('Da hat etwas nicht geklappt');
            }
        } catch (error) {
            setIsLoading(false);
            setError('Da hat etwas nicht geklappt');
        }
    }

    const delUserDetails = async (userInfo) => {
        setIsLoading(true);

        try {
            const response = await delUserDetailsOnServer(userInfo);
            setIsLoading(false);
            const { data } = response;
            if (data.status.toLowerCase() === 'ok') {
                showSuccessMessage('Eine E-Mail mit weiteren Anweißungen wurde an Sie versendet');
                setError(null);
                loadUserDetails();
            } else {
                setError(data.message);
            }
        } catch (error) {
            setIsLoading(false);
            //setError('Something went wrong');
        }
    }

    const delUserAdresses = async (addressInfo) => {
        setIsLoading(true);
        try {
            const response = await delUserAdressesOnServer(addressInfo);
            setIsLoading(false);
            const { data } = response;
            if (data.status.toLowerCase() === 'ok') {
                showSuccessMessage('Adresse wurde gelöscht');
                setError(null);
                setTimeout(() => { window.location.href = '/meine-adressen'; }, 5000);
            } else {
                setError(data.message);
            }
        } catch (error) {
            setIsLoading(false);
            //setError('Da hat etwas nicht geklappt');
        }
    }

    const showSuccessMessage = (message) => {
        setSuccessMessage(message);
        setTimeout(() => {
            setSuccessMessage(null);
        }, 300);
    }



    const initUserProfile = async () => {
        await loadUserAddress();
        await loadUserBikes();
    }





    return (
        <UserProfileProvider.Provider value={{
            isLoading,
            error,
            loadUserDetails,
            userDetails,
            setUserDetails,
            userAddress,
            setUserAddress,
            loadUserAddress,
            loadUserBikes,
            userBikes,
            setUserBikeDetails,
            userBikeDetails,
            initUserProfile,
            saveUserBike,
            successMessage,
            saveUserAddress,
            saveUserDetails,
            delUserDetails,
            delUserAdresses,
            defaultBikeData,
            userAddressDetails,
            setUserAddressDetails,
            defaultAddressData
        }}>
            {children}
        </UserProfileProvider.Provider>
    )
}
